import {TicketCategoryInterface} from "@/types/TicketCategory";

export class TicketCategory implements TicketCategoryInterface {
  entityId!: number;
  eventId!: number;
  shortDescription?: string;
  name!: string;
  price!: number;
  productId!: number;
  paymentInterval?: string
  formFields: string[]
  autoDiscountMarketingText?: string

  constructor({entityId, eventId, name, price, productId, shortDescription, paymentInterval, formFields, autoDiscountMarketingText}: TicketCategoryInterface) {
    this.entityId = entityId;
    this.eventId = eventId;
    this.name = name;

    if (typeof price == 'string') {
      this.price = parseInt(price);
    } else {
      this.price = price
    }

    this.productId = productId;
    this.shortDescription = shortDescription;
    this.paymentInterval = paymentInterval;
    this.formFields = formFields;
    this.autoDiscountMarketingText = autoDiscountMarketingText;
  }
}
